/**
 * External dependencies
 */
import { Reducer } from 'redux';

/**
 * Internal dependencies
 */
import { setEventsError } from '@/store/actions';
import initialState from '../../initialState';
import isAction from '../../isAction';

const error: Reducer<boolean | null> = (
	state = initialState.events.error,
	action
) => (isAction(action, setEventsError) ? action.payload : state);

export default error;
